import axios from 'axios';
import { loanSearch, getSelect2Response, select3Url, getSelect3Response, hlKycUrl, init, initResponse, confirm, confirmResponse, select2Url, update, updateResponse, consentUrl } from './endpointUrl';
import { headers } from './auth-header';

// SEARCH API's
export const loanSearchService = async (data: any) => {
  const response = await axios.post(loanSearch, data, { headers: headers });
  return response.data;
};

// SELECT API's
export const select2Service = async (data: any) => {
  const response = await axios.post(select2Url, data, { headers: headers });
  return response.data;
};
export const getSelect2ResponseService = async (data: any) => {
  const response = await axios.post(getSelect2Response, data, { headers: headers });
  return response.data;
};

export const select3Service = async (data: any) => {
  const response = await axios.post(select3Url, data, { headers: headers });
  return response.data;
};

export const getSelect3ResponseService = async (data: any) => {
  const response = await axios.post(getSelect3Response, data, { headers: headers });
  return response.data;
};

// HL KYC
export const hlKycService = async (txnid: any) => {
  const response = await axios.get(hlKycUrl+txnid, { headers: headers });
  return response.data;
};

// Init
export const initService = async (data: any) => {
  const response = await axios.post(init, data, { headers: headers });
  return response.data;
};

export const initResponseService = async (data: any) => {
  const response = await axios.post(initResponse, data, { headers: headers });
  return response.data;
};

// Confirm
export const confirmService = async (data: any) => {
  const response = await axios.post(confirm, data, { headers: headers });
  return response.data;
};

export const confirmResponseService = async (data: any) => {
  const response = await axios.post(confirmResponse, data, { headers: headers });
  return response.data;
};

// Update
export const updateService = async (data: any) => {
  const response = await axios.post(update, data, { headers: headers });
  return response.data;
};

export const updateResponseService = async (data: any) => {
  const response = await axios.post(updateResponse, data, { headers: headers });
  return response.data;
};

export const consentForLoanService = async (data: any) => {
  const response = await axios.post(consentUrl, data, { headers: headers });
  return response.data;
};